import ApiController from './apicontroller.js';

const getlayouturi = 'mvc/flexgridlayout/getflexgridlayout';
const updateflexgridlayout = 'mvc/flexgridlayout/updateflexgridlayout';
const deleteflexgridlayouturi = 'mvc/flexgridlayout/deleteflexgridlayout';

const getuserflexgridlayouturi = 'GetUserFlexGridLayout';
const getflexdatauri = 'GetFlexData';
const getavailablefiltersforpage = 'GetAvailableQueryFiltersForPage';
const getflexgridlayoutsuri = 'getflexgridlayouts';
const updatedefaultlayouturi = 'updatedefaultlayout';
const getavailablecolumnsforpageuri = 'GetAvailableColumnsForPage';
const createnewflexgridlayout = 'createnewflexgridlayout';

export class GridController {
  constructor (controller, customUri = null) {
    this.api = new ApiController();
    this.controller = controller;
    this.customUri = customUri;
  }

  get dataUri() {
    return (this.customUri !== null) ? this.customUri : getflexdatauri;
  }

  GetFlexGridLayout (obj) {
    return this.api.Post(getlayouturi, obj);
  }
  UpdateFlexGridLayout (obj) {
    return this.api.Post(updateflexgridlayout, obj);
  }
  DeleteFlexGridLayout (obj) {
    return this.api.Post(deleteflexgridlayouturi, obj);
  }

  GetUserFlexGridLayout (obj) {
    return this.api.Post(this.getUri(getuserflexgridlayouturi), obj);
  }
  UpdateDefaultLayout (obj) {
    return this.api.Post(this.getUri(updatedefaultlayouturi), obj);
  }
  GetFlexData (obj) {
    return this.api.Post(this.getUri(this.dataUri), obj);
  }
  GetAvailableFiltersForPage (obj) {
    return this.api.Post(this.getUri(getavailablefiltersforpage), obj);
  }
  GetFlexGridLayouts (obj) {
    return this.api.Post(this.getUri(getflexgridlayoutsuri), obj);
  }
  GetAvailableColumnsForPage (obj) {
    return this.api.Post(this.getUri(getavailablecolumnsforpageuri), obj);
  }
  CreateNewFlexGridLayout (obj) {
    return this.api.Post(this.getUri(createnewflexgridlayout), obj);
  }
  getUri (relativeuri) {
    return `${this.controller}/${relativeuri}`;
  }
}

// http://172.16.0.142/centixweb/mvc/purchasereceipt/getuserflexgridlayout
